<template>
    <span>{{ userNameWithDesignation }}</span>
</template>

<script>
    import UserRolesEnum from 'enums/UserRolesEnum'

    export function composeDisplayName({ firstName, middleName, lastName }) {
        if (middleName) {
            return [firstName, `${middleName.charAt(0)}.`, lastName].join(' ')
        }
        return [firstName, lastName].join(' ')
    }

    export default {
        props: {
            user: { type: Object, default: undefined },
        },

        data() {
            return {
                plusSign: '+',
            }
        },

        computed: {
            userName() {
                if (this.user?.userRole?.name === UserRolesEnum.ADMINISTRATOR.NAME) {
                    return UserRolesEnum.ADMINISTRATOR.NAME
                } else if (this.user?.firstName) {
                    return composeDisplayName(this.user)
                } else if (this.user?.target && this.user?.target?.name) {
                    return this.user?.target?.name
                } else if (this.user?.name) {
                    return this.user?.name
                } else if (this.user?.phone) {
                    return this.plusSign + this.user.phone
                }
                return ''
            },

            userDesignation() {
                if (this.user?.designation) {
                    return this.user?.designation
                } else if (this.user?.target && this.user?.target?.designation) {
                    return this.user?.target?.designation
                } else if (this.user?.title) {
                    return this.user?.title
                }
                return ''
            },

            userNameWithDesignation() {
                if (this.userDesignation) {
                    return `${this.userName}, ${this.userDesignation}`
                }
                return this.userName
            },
        },
    }
</script>
